// initialize wordpress API wraper
// docs: https://github.com/wp-api/node-wpapi
const WPAPI = require("wpapi");
export const wp = new WPAPI({
  endpoint: `https://stamen.com/wp-json/`,
  username: `${process.env.VUE_APP_WP_USER}`,
  password: `${process.env.VUE_APP_WP_PW}`,
  auth: true
});

// set API to pull from custom <url>/viewer/work/ endpoint
wp.workSearch = wp.registerRoute("viewer", "/work/", {
  params: ["status"]
});

wp.workItemSearchByID = wp.registerRoute("viewer", "/work/(?P<id>)", {});
wp.workItemSearchBySlug = wp.registerRoute(
  "viewer",
  "/work/(?P<itemslug>)",
  {}
);

wp.taxonomiesList = wp.registerRoute("viewer", "/terms/");

// getWork() pulls all project data from WP Api
// TODO: this will pull 100 max. we'll need it to do an arbitrary amount
export const getWork = () => {
  return new Promise((resolve, reject) => {
    wp.workSearch()
      .status(["publish", "private"])
      // .perPage(100)
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

// getWorkItem(id) pulls a single work page's data from the WP Api
export const getWorkItemByID = id => {
  return new Promise((resolve, reject) => {
    // using a preset endpoint object from WPAPI package
    wp.workItemSearchByID()
      .id(id)
      .then(data => {
        resolve(data[0]);
      })
      .catch(err => {
        reject(err);
      });
  });
};

// getWorkItem(slug) pulls a single work page's data from the WP Api
export const getWorkItemBySlug = slug => {
  return new Promise((resolve, reject) => {
    wp.workItemSearchBySlug()
      .itemslug(slug)
      .then(data => {
        resolve(data[0]);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * getTaxonomy
 */
export const getTaxonomy = () => {
  return new Promise((resolve, reject) => {
    wp.taxonomiesList()
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        reject(err);
      });
  });
};
